import React from "react";
import DataBox from "./DataBox";
import jobEmailIcon from "assets/images/job-email.svg";
import staffContactIcon from "assets/images/staffContactIcon.svg";
import addressIcon from "assets/images/address_pin_staff_detail.svg";
import ssnIcon from "assets/images/ssn_staff_detail.svg";
import styles from "../staff.module.scss";

const PersonalDetailsSection = ({
  emailId,
  contactNumber,
  t,
  socialSecurityNumber,
  address,
}) => {
  return (
    <div className={`green-main-color-form ${styles["p-20"]}`}>
      <DataBox icon={jobEmailIcon} label={t("form.fields.emailAddress")}>
        {emailId}
      </DataBox>

      <DataBox icon={staffContactIcon} label="Contact Number">
        {contactNumber || "--"}
      </DataBox>

      <DataBox icon={addressIcon} label="Address">
        {address || "--"}
      </DataBox>

      <DataBox icon={ssnIcon} label="Social Security Number">
        {socialSecurityNumber || "--"}
      </DataBox>
    </div>
  );
};

export default PersonalDetailsSection;
